module.exports = __webpack_public_path__ + "img/f90a8dc3cc10202f6f5554963fa3968e.485ed75c.png";